import React from 'react';
import { ArrowRight, Check, Star } from 'lucide-react';
import { images } from '../mock';
import { useContent } from '../context/ContentContext';

const Hero = ({ onDownload }) => {
  const { content } = useContent();
  const hero = content.hero;
  const stats = content.stats;

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#e8f5ee] via-[#f3faf6] to-white pt-36 pb-20 px-6">
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#0e9f6e]/10 blur-3xl" />
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-14 items-center relative z-10">
        <div className="rise-in">
          <span className="inline-flex items-center gap-2 rounded-full bg-white border border-[#0e9f6e]/20 px-4 py-1.5 text-xs font-semibold text-[#0c8a60] shadow-sm">
            <span className="w-2 h-2 rounded-full bg-[#0e9f6e]" /> {hero.badge}
          </span>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-700 text-[#0f1712] mt-6">
            {hero.title} <span className="text-[#0e9f6e]">{hero.titleAccent}</span> {hero.titleEnd}
          </h1>
          <p className="text-lg text-[#0f1712]/60 mt-6 max-w-md leading-relaxed">{hero.subtitle}</p>
          <div className="flex flex-wrap gap-3 mt-8">
            <button onClick={onDownload} className="inline-flex items-center gap-2 bg-[#0e9f6e] text-white rounded-xl px-7 py-4 text-sm font-semibold hover:bg-[#0c8a60] hover:scale-[1.02] active:scale-95 transition-all">
              Start selling free <ArrowRight size={16} />
            </button>
            <button onClick={onDownload} className="inline-flex items-center gap-2 bg-white text-[#0f1712] border border-[#0f1712]/10 rounded-xl px-7 py-4 text-sm font-semibold hover:border-[#0e9f6e] transition-colors">
              See how it works
            </button>
          </div>
          <div className="flex items-center gap-4 mt-8">
            <div className="flex gap-0.5">
              {[1,2,3,4,5].map((s) => <Star key={s} size={15} className="fill-[#0e9f6e] text-[#0e9f6e]" />)}
            </div>
            <p className="text-sm text-[#0f1712]/50">4.8 rating • trusted by 40k+ sellers</p>
          </div>
        </div>

        <div className="relative">
          <div className="rounded-[2rem] overflow-hidden shadow-[0_30px_80px_rgba(15,23,18,0.18)] aspect-[4/5]">
            <img src={images.hero} alt="Business owner taking a payment with FLIX" className="w-full h-full object-cover" />
          </div>
          <div className="absolute -left-4 sm:-left-8 top-10 bg-white rounded-2xl shadow-xl p-4 floaty">
            <p className="text-xs text-[#0f1712]/50">Payment received</p>
            <p className="font-display text-2xl font-700 text-[#0f1712]">+ $42.00</p>
            <div className="flex items-center gap-1 text-[#0e9f6e] text-xs font-semibold mt-1"><Check size={13} /> Settled instantly</div>
          </div>
          <div className="absolute -right-2 sm:-right-6 bottom-8 bg-[#0f1712] text-white rounded-2xl shadow-xl px-5 py-4">
            <p className="text-[10px] uppercase tracking-widest text-white/50">Today</p>
            <p className="font-display text-xl font-700">$1,284.50</p>
          </div>
        </div>
      </div>

      <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 mt-20 relative z-10">
        {stats.map((s, i) => (
          <div key={i} className="text-center rounded-2xl bg-white/70 border border-[#0f1712]/5 py-6">
            <p className="font-display text-3xl font-700 text-[#0f1712]">{s.value}</p>
            <p className="text-sm text-[#0f1712]/50 mt-1">{s.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Hero;
